import { compose, composeU } from '@bem-react/core';
import {
    Button as ButtonPresenter,
    withPinClearRound,
    withSizeL,
    withSizeM,
    withSizeS,
    withThemeAction,
    withThemeNormal,
    withThemePseudo,
    withThemeRaised,
    withTypeLink,
    withTypeSubmit,
    withViewAction,
    withViewDefault
} from '@yandex-lego/components/Button/desktop';

import './index.css';

const Button = compose(
    composeU(withThemeAction, withThemeNormal, withViewAction, withViewDefault, withThemeRaised, withThemePseudo),
    composeU(withTypeLink, withTypeSubmit),
    composeU(withSizeL, withSizeM, withSizeS),
    withPinClearRound
)(ButtonPresenter);

export default Button;
